import type { AxiosResponse } from "axios"

import { axiosClient } from "$/http"

import { ESocialLoginQueryUrl } from "@/3514/config"
import type { IJwtTokenPairDto } from "@/models/jwt"

async function socialLoginQueryFetcher(): Promise<IJwtTokenPairDto> {
    const { data }: AxiosResponse<IJwtTokenPairDto> = await axiosClient.get(ESocialLoginQueryUrl())

    return data
}

export { socialLoginQueryFetcher }
